module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":"1184472234930745"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 806
// module chunks = 184662623972074